import { defineStore, IStoreState } from "@/utils/store"

const user = defineStore({
  state: {
    uid: '',
    phone: '',
    token: '',
    cfrnid: '',
    ruid: '',
    marketFreeLogin: false, // 外投免登，如果免登的话需要额外帮注册协议
  },
  mutations: {
    update(state, data) {
      data && Object.assign(state, data)
    },
  },
})

export default user
export type IUserStoreState = IStoreState<typeof user.state>